import {
  Timestamp,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import React, { useEffect, useState } from "react";
import { nonDeliveryCodes } from "../objects/translateStates";

const useFindOrderBicciexpressPendingPayment = (companyId) => {
  const [dataOrdersPending, setOrdersPendingPayment] = useState(null);
  const [loadingPendints, setLoading] = useState(false);

  useEffect(() => {
    if (companyId) {
      setLoading(true);
      findPaymentPendingOrderBicciexpress(companyId);
    }
  }, [companyId]);

  const findPaymentPendingOrderBicciexpress = async (companyId) => {
    const startDate = new Date("2023-10-01");

    try {
      const ordersDispachtRef = collection(
        db,
        process.env.REACT_APP_COL_ORDERS
      );

      const q = query(
        ordersDispachtRef,
        where("timeStamp", ">=", startDate),
        where("billingPaymentProforma", "==", "isRequire")
      );

      const querySnapshot = await getDocs(q);

      const ordersPendingPayment = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Filtrado principal
      const ordersPropietaryDevolution = ordersPendingPayment.filter(
        (item) =>
          item.int_bicciStatus !== "Devolucion" &&
          item.int_falabella_status !== "Devolucion" &&
          item.status !== "Perdida" &&
          item.status !== "Devolucion"
      );

      // Filtro por códigos de no entrega
      const ordersFiltered = ordersPropietaryDevolution.filter((item) => {
        return !nonDeliveryCodes.has(
          String(item.int_falabella_status ?? "").trim()
        );
      });

      // Orden descendente por fecha
      ordersFiltered.sort((a, b) => (a.timeStamp < b.timeStamp ? 1 : -1));

      setOrdersPendingPayment(ordersFiltered);
    } catch (error) {
      console.log("Error al obtener pedidos pendientes:", error);
    } finally {
      setLoading(false);
    }
  };

  return { dataOrdersPending, loadingPendints };
};

export default useFindOrderBicciexpressPendingPayment;
